import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RouteSuspense } from "@/shared/routing/RouteSuspense";

const MetaPage = lazy(() =>
  import("./pages/MetaPage").then((module) => ({ default: module.MetaPage })),
);

export const metaRoutes: RouteObject[] = [
  {
    path: "meta",
    element: (
      <RouteSuspense>
        <MetaPage />
      </RouteSuspense>
    ),
  },
];
